import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { FormDateRangeInput } from '..'
import { DateRangeFilterDef } from './types'

const RangeContainer = styled.div`
  padding: 0;
  display: flex;
  gap: 10px;
  min-height: 300px;
`

function DateRangeFilter({
  filterDef,
  onChange,
}: {
  filterDef: DateRangeFilterDef
  onChange?: () => void
}) {
  const { control, setValue, getValues } = useFormContext()

  return (
    <RangeContainer data-testid="range-container">
      <Controller
        name={filterDef.keyDateStart}
        control={control}
        render={({ field }) => {
          const value: [string, string] = [
            field.value ?? '',
            filterDef.keyDateEnd ? getValues(filterDef.keyDateEnd) : '',
          ]

          return (
            <FormDateRangeInput
              inline={true}
              input={false}
              value={value}
              onChange={(val?: string[] | null) => {
                const dateStart = val?.[0]
                const dateEnd = val?.[1]

                field.onChange(dateStart)

                setValue(filterDef.keyDateEnd, dateEnd, {
                  shouldDirty: true,
                })

                if (onChange) onChange()
              }}
            />
          )
        }}
      />
    </RangeContainer>
  )
}

export default DateRangeFilter
